var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.3521 86.7546L100.239 54.5185L132.143 86.7716L150.697 68.0137L100.239 17L49.7981 67.9967L68.3521 86.7546Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2493 99.9969L36.6957 81.2393L18.1411 99.9978L36.6948 118.755L55.2493 99.9969Z",
    fill: "#F3BA2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3521 113.245L100.239 145.482L132.141 113.23L150.706 131.977L150.697 131.988L100.239 183L49.7968 132.005L49.7709 131.978L68.3521 113.245Z",
    fill: "#F3BA2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.785 118.765L182.339 100.006L163.785 81.2485L145.231 100.007L163.785 118.765Z",
    fill: "#F3BA2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.059 99.9902H119.067L100.239 80.9556L86.3253 95.0224H86.324L84.7263 96.639L81.4284 99.9731L81.4025 99.9993L81.4284 100.027L100.239 119.044L119.067 100.01L119.076 99.9993L119.059 99.9902Z",
    fill: "#F3BA2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.1b9d7060f801881e7cf17f799a94c87f.svg";
export { ForwardRef as ReactComponent };